import React, { Fragment, useEffect, useState } from "react";
import { useArgusAuth } from "../../hooks/useArgusAuth";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Backdrop, CircularProgress, Container } from "@mui/material";
import OrderConfirmation from "../../components/OrderConfirmation";
import { ApiCallStatus } from "../../utils/constants";
import { fetchOrderConfirmationData, fetchOrderData, fetchOrderDataById } from "../PageFunctions/orderFunctions";
import { useCart } from "react-use-cart";
import { fetchProductsBySkus } from "../PageFunctions/productFunctions";

const OrderConfirmationPage = ({
	genericDataLoaded,
	genericPageContent
}) => {
	const {orderId} = useParams();
	const {isAuthenticated, isLoading} = useArgusAuth();
	const [orderData, setOrderData] = useState(null);

	const [orderDataFetchCallStatus, setOrderDataFetchCallStatus] = useState(ApiCallStatus.NotStarted);

	const fetchOrderConfirmationDataAsync = async () => {
		if (!orderId) return;

		await fetchOrderConfirmationData({
			orderId,
			setOrderData,
			setStatusInProgress: () => setOrderDataFetchCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setOrderDataFetchCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setOrderDataFetchCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setOrderDataFetchCallStatus(ApiCallStatus.Error)
		});
	};

	const unauthorizedCalls = async () => {
		await Promise.all([
			fetchOrderConfirmationDataAsync()
		]);
	};

	const authorizedCalls = async () => {
		await Promise.all([

		]);
	};

	useEffect(() => {
		if (genericDataLoaded === true && isLoading === false) {
			if (isAuthenticated === false) {
				unauthorizedCalls();
			} else {
				authorizedCalls();
				unauthorizedCalls();
			}
		}
	}, [genericDataLoaded, isAuthenticated, isLoading]);

	const allLoadingStates = [
		orderDataFetchCallStatus
	];

	const pageIsLoading = allLoadingStates.includes(ApiCallStatus.InProgress) || genericDataLoaded === false || isLoading === true;

	return (
		<Container maxWidth="lg">
			<OrderConfirmation
				orderData={orderData}
			/>
			<Backdrop
				sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
				open={pageIsLoading}
			>
				<CircularProgress color="inherit"/>
			</Backdrop>
		</Container>
	)
}

export default OrderConfirmationPage;